import React from "react";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import { search } from "amadeusredux/lib/api";
import { useDispatch } from "react-redux";
import { setMap } from "amadeusredux/lib/systemSlice";
import { FaTimes } from "react-icons/fa";

export class MapContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { zoom: 13 };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.visible !== nextProps.visible) return true;
    if (this.props.center) {
      if (
        this.props.center.lat === nextProps.center.lat &&
        this.props.center.lng === nextProps.center.lng
      ) {
        return false;
      }
    }

    return true;
  }

  render() {
    return (
      <>
        {!this.props.free && this.props.visible && (
          <div
            style={{
              backgroundColor: "white",
              position: "fixed",
              width: window.innerWidth / 2,
              bottom: window.innerHeight - 200 + 16,
              marginLeft: "16px",
              right: 16,
              height: "32px",
              display: "flex",
              border: "#adadad solid",
              borderWidth: "1px 1px 0px 1px",
            }}
          >
            <div style={{ flexGrow: 1 }}></div>
            <div
              style={{ cursor: "pointer", marginRight: 8 }}
              onClick={() => this.props.closeMap()}
            >
              <FaTimes style={{ marginTop: 8 }} />
            </div>
          </div>
        )}
        <Map
          google={this.props.google}
          zoom={this.state.zoom}
          initialCenter={this.props.center}
          center={this.props.center}
          onZoomChanged={(map, b) => this.setState({ zoom: b.zoom })}
          onBoundsChanged={(map, mapObj) => {
            this.props.setNorthEast({
              lat: mapObj.getBounds().getNorthEast().lat(),
              lng: mapObj.getBounds().getNorthEast().lng(),
            });
            this.props.setSouthWest({
              lat: mapObj.getBounds().getSouthWest().lat(),
              lng: mapObj.getBounds().getSouthWest().lng(),
            });
          }}
          visible={this.props.visible}
          streetViewControl={false}
          containerStyle={{
            marginLeft: "16px",
            width:  window.innerWidth / 2,
            position: this.props.free ? "relative" : "fixed",
            bottom: 16,
            right: this.props.visible ? 16 : 5000,
            height: window.innerHeight - 200,
            border: this.props.visible ? "#adadad solid" : "",
            borderWidth: this.props.visible ? "0px 1px 1px 1px" : "",
          }}
        >
          {Array.isArray(this.props.markers) &&
            this.state.zoom >= 13 &&
            this.props.markers.map((e) => {
              return (
                <Marker
                  key={e.id + "" + Math.random()}
                  icon={{
                    path: "M19,7H11V14H3V5H1V20H3V17H21V20H23V11A4,4 0 0,0 19,7M7,13A3,3 0 0,0 10,10A3,3 0 0,0 7,7A3,3 0 0,0 4,10A3,3 0 0,0 7,13Z",
                    //path:
                    //  "M2.5,19H21.5V21H2.5V19M9.68,13.27L14.03,14.43L19.34,15.85C20.14,16.06 20.96,15.59 21.18,14.79C21.39,14 20.92,13.17 20.12,12.95L14.81,11.53L12.05,2.5L10.12,2V10.28L5.15,8.95L4.22,6.63L2.77,6.24V11.41L4.37,11.84L9.68,13.27Z",
                    fillColor: "#00bded",
                    fillOpacity: 1,
                    scale: 1.2,
                    strokeColor: "black",
                    strokeWeight: 1,
                    anchor: new window.google.maps.Point(12, 12),
                    labelOrigin: new window.google.maps.Point(12, -5),
                  }}
                  position={e.position}
                  label={e.label}
                  name={e.label}
                />
              );
            })}
        </Map>
      </>
    );
  }
}
export default GoogleApiWrapper({
  apiKey: "AIzaSyAWVaImrLrd81sKF_HWh-pO8dwT25zzM9c",
})(MapContainer);

export const GeoSearch = () => {
  const dispatch = useDispatch();
  return (
    <span
      className="reactmap"
      onClick={() => {
        //search(dispatch, false, true);
      }}
    >
      {/*-*/}
    </span>
  );
};
